import React from 'react'
import heroimg from "../assets/heroimg.jpeg"
import { Link } from 'react-scroll'
import { MdFullscreen, MdOutlineKeyboardArrowRight } from "react-icons/md"




function About() {
    return (
        <div name="about" className=' w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'>
            <div className='max-w-screen-lg p-4 mx-auto justify-center w-full h-full'>

                <div className=''>
                    <p className='text-4xl tracking-wide font-bold inline border-gray-500'>About</p>
                </div>

                <section className='flex md:mt-40'>
                    {/* To seperate stuff */}
                    <div className='md:flex justify-evenly py-10 my-auto'>
                        {/* Left text */}
                        <div name="Left" className='flex justify-between w-full md:w-1/2'>
                            <div className='text-lg justify-between flex pr-10 flex-col'>
                                {/* <br /> */}
                                {/* <p className='text-md'>Is it that time of the year again where <b>you</b> are engaged in the process of solving that soul-searching question of
                            </p> */}
                                {/* <br /> */}
                                {/* <i className="text-lg">"Is this the <u>right</u> person for the job?" <p className='text-sm'> -you</p> </i>
                            <br />
                            <p className='text-md'>While I'm currently a student in computing, my previous background in social services has taught me a method that can be inherited by all of types of jobs and that, is to <b><u>listen</u></b>. One way I implement this is to ask questions. But since time is precious; for you, I only have one: </p> 
                            <br />
                            <p className='text-2xl'> Does your idea need... </p>

                            <ul className='list-disc ml-5'>
                                <li>A quick study</li>
                                <li>An excellent communicator</li>
                                <li>A Javascript developer</li>
                            </ul>
                            <br /> */}
                                <p>
                                    Hello! I'm currently learning to be a software developer at BCIT. After just a few months of
                                    learning to program, I have been happy to use my knowledge to build websites and develop
                                    applications.
                                </p>

                                <p>
                                    I have developed applications in Java, Javascript and Python. Below are the programs I have developed during my program.
                                </p>
                                <div className='flex justify-end'>
                                    <Link to="portfolio" smooth duration={500} className=' group text-white justify-start w-fit px-6 py-3 my-2 flex rounded-md bg-slate-500
                            cursor-pointer'>
                                        Portfolio
                                        <span className='group-hover:rotate-90 duration-300'>
                                            <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
                                        </span>
                                    </Link>
                                </div>


                            </div>
                        </div>

                        {/* img */}
                        <div className='w-full md:flex flex-col justify-center md:w-2/3 content-center'>
                            <img className='py-1 md:flex rounded-2xl mx-auto w-2/3 md:w-full' src={heroimg} />
                        </div>



                    </div>
                </section>



            </div>

        </div>
    )
}

export default About